import PropTypes from 'prop-types';
import React from 'react';

const UserMessage = props => <div className="message-ribbon">{props.text}</div>;

UserMessage.propTypes = {
    text: PropTypes.string.isRequired,
};

export default UserMessage;
